/**
 * Countdowns time
 */

let countdownTimer = document.getElementById('next-day-countdown-timer');
let hoursElement = document.getElementById('role-hours');
let minutesElement = document.getElementById('role-minutes');
let whenElement = document.getElementById('role-when')

let countdownTimerDeadline = new Date();
let deadline = [14,0,0];
if (countdownTimer.dataset.deadline) {
  deadline = countdownTimer.dataset.deadline.split(':');
}
countdownTimerDeadline.setHours(deadline[0],deadline[1],deadline[2],0);

function initializeClock() {
	updateClock();
	this.timeinterval = setInterval(function(){
		updateClock();
	}, 1000);
};

function updateClock () {
	var t = getTimeRemaining();

	hoursElement.innerHTML =('00' + t.hours).slice(-2);
	minutesElement.innerHTML = ('00' + t.minutes).slice(-2);
	let now = getNow();
	if ( now.getDay() == 5 ) whenElement.innerHTML = countdownTimer.dataset.monday;
	else whenElement.innerHTML = countdownTimer.dataset.tomorrow;

	if (t.total <= 0 || now.getDay() == 6 || now.getDay() == 7 ) {
		clearInterval(this.timeinterval);
		countdownTimer.style.display = "none";
	} else {
		countdownTimer.style.display = "block";
	}
};

function getNow() {
  let now = new Date();
  if (countdownTimer.dataset.servertime) {
    var servertime = countdownTimer.dataset.servertime.split(':');
    now.setHours(servertime[0],servertime[1],0);
  }
  return now;
}

function getTimeRemaining () {
	var t = Date.parse(countdownTimerDeadline) - Date.parse(getNow());
	var seconds = Math.floor((t / 1000) % 60);
	var minutes = Math.floor((t / 1000 / 60) % 60);
	var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
	var days = Math.floor((t / (1000 * 60 * 60 * 24)));

	return {
		'total': t,
		'days': days,
		'hours': hours,
		'minutes': minutes,
		'seconds': seconds
	};
};

initializeClock();
